<div>
  <div class="modal-header b pb-0 pt-3 px-3">
    <h6 class="modal-title font-weight-500 f-14 text-defualt">Send Email</h6>
    <button data-testid="auto-app-candidate-email-button-1" type="button" class="close font-weight-normal pb-2" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body px-3 pb-0 pt-3">
    <div class="form-group mb-0">
      <form [formGroup]="bulkemail_Form">
      <div class="row mb-3">
        <div class="col-8">
          <div class=" col px-0 pb-3" *ngIf="integratedemailsarray && integratedemailsarray.length == 0">
            <span class="text-webbtree-green"  routerLink="/settings/email-integration" (click)="modalService.dismissAll()">
              <u>Click here </u>
              </span>to send emails using your official email ID <i class="fas fa-info-circle text-dis ml-2" [ngbTooltip]="xD" placement="right"></i>
            <ng-template #xD>
              <span class="f-12 gray-text"> 
                Integrate your inbox and send emails to candidates using your official email ID through Webbtree </span>
            </ng-template>
            </div>
          <div class="row mb-4" (click)="collapseALldiv()">
            <div class="col">
              <label for="from" class="f-12 mb-0">From <span class="text-danger">*</span>
              </label>
              <div class="position-relative">
                <section *ngIf="integratedemailsarray && integratedemailsarray.length == 0">
                  <input data-testid="auto-app-candidate-email-input-1" type="email"  placeholder="Enter email id" class="wc-form-control nobg p-none" formControlName="from">
                </section>

                <section *ngIf="integratedemailsarray && integratedemailsarray.length > 0">
                  <p-dropdown [options]="integratedemailsarray" formControlName="from" (onChange)="selectFromEmail($event.value)" optionValue="integrationplatform"  [style]="{'width':'100%'}">
                    <ng-template pTemplate="selectedItem">
                      <div class="country-item country-item-value">
                          <i class="fas fa-email"> </i>
                          <div> <img src={{selectedItem.icon}} style="width: 14px;height: 11px;" class="mr-2">  {{username}} <{{selectedItem.emailid}}></div>
                      </div>
                  </ng-template>
                    <ng-template let-item pTemplate="item">
                       
                    </ng-template>
                </p-dropdown>
                </section>
                <p class="text-danger f-12 pt-1"
                      *ngIf="bulkemail_Form['controls'].from.hasError('required') && (bulkemail_Form['controls'].from.dirty || bulkemail_Form['controls'].from.touched)">
                      From is required</p>
              </div>
            </div>

          </div>

        
          <div class="row mb-4" *ngIf="emailforCandidate">
            <div class="col">
              <label for="to" class="f-12">To <span class="text-danger">*</span>
              </label>
                <div class="position-relative">
                  <span class="selectdrop-down position-absolute tr0 f-12 mt-1"><i class="fas fa-chevron-down"></i></span>
                  <select data-testid="auto-app-candidate-email-select-1" class="wc-form-control nobg email-selection" (change)="selectcandidateemail($event)">
                    <option [value]="null" disabled>Select email Id</option>
                    <option *ngFor="let email of candidate_emaillist" [value]="email.todisplay">{{email.todisplay}}
                    </option>
                  </select>
                  <!-- <input data-testid="auto-app-candidate-email-input-2" type="email"  placeholder="Enter email id" class="wc-form-control nobg" formControlName="sentto"> -->
                  <p class="text-danger f-12 pt-1"
                        *ngIf="bulkemail_Form['controls'].sentto.hasError('required') && (bulkemail_Form['controls'].sentto.dirty || bulkemail_Form['controls'].sentto.touched)">
                        From is required</p>
                </div>
            </div>
          </div>

          <div id="exp" class="col px-0 mb-4" *ngIf="!emailforCandidate">
            <label for="to" class="f-12">To <span class="text-danger">*</span> </label>
            <div class="col d-flex justify-content-between collapseBtn collapsed newcollapsed" data-bs-toggle="collapse"
              data-bs-target="#experience" style="    padding-top: 8px;
              padding-bottom: 8px;">
              <span class="f-14 position-relative mb-1" style="top:5px;">{{BulkCandidateEmail.length}} recipient<span *ngIf="BulkCandidateEmail.length>1">s</span> selected</span>
              <span class="position-relative" style="top:2px;">
                <span class="updownarrow"><i class="fas fa-chevron-down f-12"></i></span>
                <span class="updownarrow"><i class="fas fa-chevron-up f-12"></i></span>
              </span>
            </div>
            <div class="col position-absolute collapse-div pt-2 pb-1 collapse" id="experience" #asd>
              <section class="mb-1" *ngFor="let candidate of sortBY(candidatedetails)">
                <div class="d-flex" [ngClass]="{'text-disabled' : !candidate.checked}">
                  <label class="wc-checkbox-sm mr-3">
                    <input data-testid="auto-app-candidate-email-input-3" type="checkbox" (change)="addemailstosend($event,candidate)" [checked]="candidate.checked" [disabled]="!candidate.checked">
                    <i class="fas fa-check f-10"  [ngClass]="{'bb-777' : !candidate.checked}"></i>
                  </label>
                  <span style="width: 350px" class="f-12">
                    {{candidate.name}} <{{candidate.emailid ? candidate.emailid : 'NA'}}>
                  </span>
                </div>
              </section>
            </div>
            <p *ngIf="BulkCandidateEmail.length == 0" class="text-danger f-12 pt-1">
              Please select atleast one candidate
            </p>
            <p class="text-danger f-12 pt-1 mb-1" *ngIf="candidate_withoutemail?.length > 0">
              Total candidates selected: {{totalCandidates}}
            </p>
            <p class="text-danger f-12 pt-1 mb-1" *ngIf="candidate_withoutemail?.length > 0">
             {{candidate_withoutemail?.length}} Candidate<span *ngIf="candidate_withoutemail?.length > 1">s</span> 
             <span *ngIf="candidate_withoutemail?.length > 1"> do</span>
             <span *ngIf="candidate_withoutemail?.length == 1"> does</span> not have email id<span *ngIf="candidate_withoutemail?.length > 1">s</span>
            </p>
            <p class="text-danger f-12 pt-1 mb-1" *ngIf="unsubscribedCandidateCount > 0">
              {{unsubscribedCandidateCount}} Candidate<span *ngIf="unsubscribedCandidateCount > 1">s</span> 
              <span *ngIf="unsubscribedCandidateCount > 0"> Unsubscribed from email</span>
             </p>
          </div>
          <!-- <div class="row mb-4" *ngIf="!emailforCandidate">
            <div class="col">
              <label for="to" class="f-12">To <span class="text-danger">*</span>
              </label>
                <div class="position-relative">
                  <input data-testid="auto-app-candidate-email-input-4" type="email"  placeholder="{{bulkEmails[0].length}} candidates selected" disabled class="wc-form-control nobg">
                  <p class="text-danger f-12 pt-1 ml-2" *ngIf="(bulkEmails[0].length - BulkCandidateEmail.length) > 0 ">{{bulkEmails[0].length - BulkCandidateEmail.length}} 
                    candidates does not have email ID</p>
                </div>
            </div>
          </div> -->

          <div class="row mb-4">
            <div class="col">
              <label for="to" class="f-12">Email template
              </label>
              <div class="position-relative">
                <span class="selectdrop-down position-absolute tr0 f-12 mt-1"><i class="fas fa-chevron-down"></i></span>
                <select data-testid="auto-app-candidate-email-select-2" class="wc-form-control nobg" (change)="selectedTemplateOption($event)">
                  <option [value]="null" disabled>Select email template</option>
                  <option *ngFor="let template of customtempList" [value]="template.templateid">{{template.actionname}}
                  </option>
                </select>
              </div>
            </div>



          </div> 
          <div class="row mb-0">

            <div class="col">
              <label for="subject" class="f-12">Subject <span class="text-danger">*</span>
              </label>
              <div class="position-relative">
                <input data-testid="auto-app-candidate-email-input-5" type="text" placeholder="Enter Subject" class="wc-form-control nobg" #subject
                (input)="getCursorPosition('subject');" (click)="getCursorPosition('subject');" formControlName="subject">
                <p class="text-danger f-12 pt-1 mb-0"
                  *ngIf="bulkemail_Form['controls'].subject.hasError('required') && (bulkemail_Form['controls'].subject.dirty || bulkemail_Form['controls'].subject.touched)">
                  Subject is required</p>
              </div>
            </div>
          </div>

        </div>
        <div class="col-4 d-flex align-items-end px-3 mb-0"  (click)="collapseALldiv()">

          <div class="position-relative" [ngClass]="{'mb-4':bulkemail_Form['controls'].subject.hasError('required') && (bulkemail_Form['controls'].subject.dirty || bulkemail_Form['controls'].subject.touched)}">
            <label class="f-12">Placeholders</label>
            <span class="selectdrop-down position-absolute tr0 f-12 mt-6"><i class="fas fa-chevron-down"></i></span>
            <select data-testid="auto-app-candidate-email-select-3" class="wc-form-control nobg position-relative" [disabled]="!placeid" (change)="selectplaceholder($event)">
              <option value=null [selected]='!placeid'>Select placeholder</option>
              <option *ngFor="let x of placeholderlist" [value]="x.value">{{x.value}}</option>
            </select>
          </div>
        </div>

      </div>
      <div class="row mb-4" (click)="collapseALldiv()">
        <div class="col mt-1">
          <label for="emaiteplate" class="f-12">Email Template body <span class="text-danger">*</span>
          </label>
          <div>
            <!-- <angular-editor id="template" [config]="editorConfig" name="template" formControlName="emailtemplate"
              (input)="getCursorPosition('body');" (click)="getCursorPosition('body');">
            </angular-editor> -->
            <p-editor formControlName="emailtemplate" [style]="{'height':'250px'}" id="template" (onTextChange)="getCursorPosition('body');" (click)="getCursorPosition('body');">
              <ng-template pTemplate="header">
            <span class="ql-formats">
              <select data-testid="auto-app-candidate-email-select-4" class="ql-size">
                <option value="small">Tiny</option>
                <option selected></option>
                <option value="large">Subheading</option>
                <option value="huge">Heading</option>
              </select>
            </span>
            <span class="ql-formats">
              <button data-testid="auto-app-candidate-email-button-2" type="button" class="ql-bold" aria-label="Bold"></button>
              <button data-testid="auto-app-candidate-email-button-3" type="button" class="ql-italic" aria-label="Italic"></button>
              <button data-testid="auto-app-candidate-email-button-4" type="button" class="ql-underline" aria-label="Underline"></button>
              <button data-testid="auto-app-candidate-email-button-5" type="button" class="ql-list" aria-label="Unordered list" value="bullet"></button>
              <button data-testid="auto-app-candidate-email-button-6" type="button" class="ql-link" aria-label="Insert link" (click)="testscript()"></button>
              <button data-testid="auto-app-candidate-email-button-7" type="button" class="ql-clean" aria-label="Remove Styles"></button>
          </span>
          <span class="ql-formats">
            <select data-testid="auto-app-candidate-email-select-5" title="Text Alignment" class="ql-align" >
              <option selected>Gauche</option>
              <option value="center" label="Center"></option>
              <option value="right" label="Right"></option>
              <option value="justify" label="Justify"></option>
            </select>            
          </span> 
          <span class="ql-formats">
            <button data-testid="auto-app-candidate-email-button-8" aria-label="Link" class="ql-link"></button>
          </span>
          </ng-template>
      </p-editor>
            <p class="text-danger f-12 pt-1"
              *ngIf="bulkemail_Form['controls'].emailtemplate.hasError('required') && (bulkemail_Form['controls'].emailtemplate.dirty || bulkemail_Form['controls'].emailtemplate.touched)">
              Email body is required</p>
              <p *ngIf="bulkemail_Form['controls'].emailtemplate.hasError('scriptTagError')" [ngClass]="['text-left','my-1','text-danger']">
                Script tags are not allowed</p>
          </div>
        </div>

      </div>
        <div class="mb-0">
          <div class="col d-flex align-items-center px-0">
            <span>Attachment</span>
            <div class="ml-2 p-0 uploadFile wc-form-control w-50">
              <input data-testid="auto-app-candidate-email-input-6" type="file" class=" nobg" name="
                                  cvupload" id="cv" (change)="uploadFile($event)"
                accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
              <span class="anchor-text pointer">Choose your file</span>
            </div>
          </div>
          <!-- <div class="d-flex align-items-center"> -->
            <p *ngIf="special_char_error== true" [ngClass]="['text-left','my-1','text-danger']">
              File should not contain any special characters.</p>
            <p [ngClass]="['text-left','my-1','text-danger']" *ngIf="incorrectdoc==true">File type should be .doc
              .pdf .docx .txt</p>
              <p [ngClass]="['text-left','my-1','text-danger']" *ngIf="filesizeExceeded==true">File size should not exceed more then 5 mb</p>
          <!-- </div> -->
         
        </div>
        <div class="row">
          <div class="col">
            <span *ngFor="let doc of uploadedFiles" class="wc-ats-chip mr-2 mb-2 d-inline-block">{{doc.filename}}
              <span class="ml-2 pointer " (click)="removeFile(doc)"><i class="fas fa-times-circle"></i></span>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer b pb-3 px-3">
    <div class="col d-flex mx-auto pr-0 my-0">
      <button data-testid="auto-app-candidate-email-button-9" type="button" class="btn-trms-small" data-dismiss="modal"
        (click)="SendEmailToCandidate();">Send
      </button>
    </div>
  </div>
</div>

<ng-template #error class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-email-button-10" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-email-button-11" class="btn-trms-small" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noEmailModal class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-email-button-12" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/unauthorised.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">Please select atleast one candidate with an email id</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-email-button-13" class="btn-trms-small"
            (click)="modalService.dismissAll()">Done</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pl-1">
          <h5 class="modal-title f-16 text-defualt" id="createnote">Email </h5>
          <button data-testid="auto-app-candidate-email-button-14" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="mb-3 mt-1 f-14 SuccessBoxed d-flex">
          <i class="fas fa-check-circle ml-2 mr-5 pt-1 f-28"></i>
          <span class="f-14 mt-3 font-weight-500"> Email Sent Succesfully </span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col pl-1">
          <p class="f-14 font-weight-500">Update candidate pipeline status
            <i class="fas fa-info-circle text-dis"[ngbTooltip]="pipelineplaceHolder"
              placement="right"></i>
          </p>

          <ng-template #pipelineplaceHolder>
            <p> <span class="hot-dot mr-1"></span>Hot candidate </p>
            <p class="mr-3"> All Signs Point To “Go” </p>
            <p> <span class="warm-dot mr-1"></span>Warm candidate </p>
            <p class="mr-3"> Interested, But Not Ready,
              Able Or A Good Fit
            </p>
            <p> <span class="cold-dot mr-1 "></span>Cold candidate </p>
            <p class="mr-3"> Casual Contacts and Candidates
              For Re-engagement
            </p>
          
          </ng-template>


          <p class="f-12">Pipeline Status <span class="text-danger">*</span></p>
          <span class="position-relative mb-1 d-flex col-6 pl-0">
            <select data-testid="auto-app-candidate-email-select-6" class="nobg wc-form-control pipeline-text-border" [(ngModel)]="talentvalue">
              <option value="null" disabled selected>Select</option>
              <option *ngFor="let status of pipeline_list" [value]="status"> {{status}} Candidate </option>
          </select>
            <span class="selectdrop-down position-absolute f-12 mt-3 mr-5 tr-x"> <i
                class="fas fa-chevron-down"></i></span>
          </span>
          <p class="text-danger f-12">
            {{talentErrorMessage}}
        </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-email-button-15" class="btn-trms-small" (click)="SaveTalent();">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>